import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CallbackWrapperService {
  private subjects: { [key: string]: Subject<unknown> } = {};

  getSubject<T>(key: string): Subject<T> {
    if (!this.subjects[key]) {
      this.subjects[key] = new Subject<unknown>();
    }
    return this.subjects[key] as Subject<T>;
  }
}

// List all const subject string names to prevent mistyping in future
export const FormControlRerenderSubject = 're-render-form-control';
export const SelectClosedSubject = 'select-closed';
export const PinRejectedSubject = 'pin-rejected';
